// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Mcp-ResumePage{padding:0 20px}.Mcp-ResumePage.recomandationPage .Mcp-SimulatorSteps{display:none}@media(min-width:769px){.Mcp-ResumePage.recomandationPage .Mcp-SimulatorSteps{display:block}}", ""]);
// Exports
module.exports = exports;
